// components/ProductImage.jsx - Product Image Component
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { conf } from '../../../confg';

const ProductImage = ({ product, discounted }) => {
  return (
    <div className='product-image-container'>
      <LazyLoadImage
        src={conf.image_url + product['pictures'][0]?.url}
        alt={product['products']['accounting_name_product']}
        className='product-image'
        width={160}
        height={180}
        style={{ borderRadius: '8px' }}
      />
      {/* {discounted && <div className='discount-badge'>{product['discount']['percent']}%</div>} */}
    </div>
  );
};

export default ProductImage;
